module.exports = __webpack_public_path__ + "static/android-icon-192x192.87991f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/android-icon-192x192.png
// module id = 370
// module chunks = 114276838955818